/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Meta_TitleInputs */

const en_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Egly Method | Mark Egly Golf`)
};

const es_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El método Egly | Mark Egly Golf`)
};

const de_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-Methode | Mark Egly Golf`)
};

const zh_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const ar_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منهج Egly | Mark Egly Golf`)
};

const fr_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La méthode Egly | Mark Egly Golf`)
};

const vi_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương pháp Egly | Mark Egly Golf`)
};

const sw_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mbinu ya Egly | Mark Egly Golf`)
};

const th_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิธี Egly | Mark Egly Golf`)
};

const bs_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly metoda | Mark Egly Golf`)
};

const ja_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const ko_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly 메서드 | Mark Egly Golf`)
};

const pt_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Método Egly | Mark Egly Golf`)
};

const it_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Metodo Egly | Mark Egly Golf`)
};

const sv_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const nl_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const da_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const nb_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const fi_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const pl_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoda Egly | Mark Egly Golf`)
};

const ru_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метод Egly | Mark Egly Golf`)
};

const tr_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const hi_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const id_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const ms_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const cs_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

const el_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η Μέθοδος Egly | Mark Egly Golf`)
};

const he_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיטת Egly | Mark Egly Golf`)
};

const af_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-metode | Mark Egly Golf`)
};

const hu_method_meta_title = /** @type {(inputs: Method_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "The Egly Method \| Mark Egly Golf" |
*
* @param {Method_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_meta_title = /** @type {((inputs?: Method_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_meta_title(inputs)
	if (locale === "de") return de_method_meta_title(inputs)
	if (locale === "zh") return zh_method_meta_title(inputs)
	if (locale === "ar") return ar_method_meta_title(inputs)
	if (locale === "fr") return fr_method_meta_title(inputs)
	if (locale === "vi") return vi_method_meta_title(inputs)
	if (locale === "sw") return sw_method_meta_title(inputs)
	if (locale === "th") return th_method_meta_title(inputs)
	if (locale === "bs") return bs_method_meta_title(inputs)
	if (locale === "ja") return ja_method_meta_title(inputs)
	if (locale === "ko") return ko_method_meta_title(inputs)
	if (locale === "pt") return pt_method_meta_title(inputs)
	if (locale === "it") return it_method_meta_title(inputs)
	if (locale === "sv") return sv_method_meta_title(inputs)
	if (locale === "nl") return nl_method_meta_title(inputs)
	if (locale === "da") return da_method_meta_title(inputs)
	if (locale === "nb") return nb_method_meta_title(inputs)
	if (locale === "fi") return fi_method_meta_title(inputs)
	if (locale === "pl") return pl_method_meta_title(inputs)
	if (locale === "ru") return ru_method_meta_title(inputs)
	if (locale === "tr") return tr_method_meta_title(inputs)
	if (locale === "hi") return hi_method_meta_title(inputs)
	if (locale === "id") return id_method_meta_title(inputs)
	if (locale === "ms") return ms_method_meta_title(inputs)
	if (locale === "cs") return cs_method_meta_title(inputs)
	if (locale === "el") return el_method_meta_title(inputs)
	if (locale === "he") return he_method_meta_title(inputs)
	if (locale === "af") return af_method_meta_title(inputs)
	if (locale === "hu") return hu_method_meta_title(inputs)
	return en_method_meta_title(inputs)
});